import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPrint, faEdit, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import PaymentStatusGroup from './PaymentStatusGroup';

const OrderCard = ({ order, onView, onPrint, onEdit, onSendEbill, tablesVPAMapping, staffIdMap, formateDate }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-300 p-4 space-y-3" data-testid={`order-card-${order.billNo}`}>
      {/* Header */}
      <div className="flex justify-between items-start">
        <div className="space-y-1">
          <div className="font-semibold text-gray-900 text-lg" data-testid={`order-card-bill-no-${order.billNo}`}>
            Bill #{order.billNo}
          </div>
          <div className="text-sm text-gray-600">
            {order.typeOfOrder === "Takeaway" ? "Parcel" : `${tablesVPAMapping[order.tableVPA] || "NA"}`}
          </div>
          <div className="text-xs text-gray-500">
            {staffIdMap[order.staffId]?.name || "No Staff"}
          </div>
        </div>
        
        {/* Payment & Status */}
        <div className="text-right">
          <PaymentStatusGroup
            paymentMethod={order.paymentmethod}
            status={order.billStatus}
            isCanceled={order.canceled}
            orderType={order.orderType}
          />
        </div>
      </div>

      {/* Amount Section */}
      <div className="bg-gray-50 rounded-md p-3">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-gray-700">Total Amount</span>
          <span className="text-xl font-bold text-gray-900" data-testid={`order-card-amount-${order.billNo}`}>
            ₹{Number.parseFloat(order.billTxnLogs.total).toFixed(2)}
          </span>
        </div>
        
        <div className="space-y-1 text-xs">
          <div className="flex justify-between text-gray-600">
            <span>Subtotal:</span>
            <span>₹{Number.parseFloat(order.billTxnLogs.subTotal).toFixed(2)}</span>
          </div>
          {order.billTxnLogs.discount > 0 && (
            <div className="flex justify-between text-green-600">
              <span>Discount:</span>
              <span>-₹{Number.parseFloat(order.billTxnLogs.discount).toFixed(2)}</span>
            </div>
          )}
          {order.billTxnLogs.service && order.billTxnLogs.serviceAmount > 0 && (
            <div className="flex justify-between text-purple-600">
              <span>Service Charge ({order.billTxnLogs.servicePercentage}%):</span>
              <span>₹{Number.parseFloat(order.billTxnLogs.serviceAmount).toFixed(2)}</span>
            </div>
          )}
          {order.billTxnLogs.tip > 0 && (
            <div className="flex justify-between text-blue-600">
              <span>Tip:</span>
              <span>₹{order.billTxnLogs.tip}</span>
            </div>
          )}
        </div>

        {/* Partial Payment Details */}
        {order.paymentmethod === "partial" && order?.partialAmoutsplit && (
          <div className="mt-2 pt-2 border-t border-gray-300">
            <div className="text-xs font-medium text-gray-700 mb-1">Split Payment:</div>
            {order.partialAmoutsplit.map((ele, idx) =>
              ele.amount > 0 && (
                <div key={idx} className="flex justify-between text-xs text-gray-600">
                  <span>{ele.name}:</span>
                  <span>₹{ele.amount}</span>
                </div>
              )
            )}
          </div>
        )}
      </div>

      {/* Time and Actions */}
      <div className="flex justify-between items-center pt-2 border-t border-gray-100">
        <div className="text-sm text-gray-600">
          <div className="font-medium">
            {new Date(order.createdAt).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}
          </div>
          <div className="text-xs text-gray-500">
            {formateDate(order.createdAt)}
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <button
            onClick={() => onView(order)}
            className="p-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md transition-colors duration-200"
            title="View Details"
          >
            <FontAwesomeIcon icon={faEye} className="w-4 h-4" />
          </button>
          {!order.canceled && (
            <button
              onClick={() => onPrint(order)}
              className="p-2 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-md transition-colors duration-200"
              title="Print Bill"
            >
              <FontAwesomeIcon icon={faPrint} className="w-4 h-4" />
            </button>
          )}
          {!order.canceled && (
            <button
              onClick={() => onEdit(order)}
              className="p-2 text-gray-600 hover:text-orange-600 hover:bg-orange-50 rounded-md transition-colors duration-200"
              title="Edit Order"
            >
              <FontAwesomeIcon icon={faEdit} className="w-4 h-4" />
            </button>
          )}
          <button
            onClick={() => onSendEbill && onSendEbill(order)}
            className="p-2 text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-md transition-colors duration-200"
            title="Send E-Bill"
          >
            <FontAwesomeIcon icon={faPaperPlane} className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderCard; 